<!--
================================================
Vue de l'espace perso pour gérer les réglages utilisateur
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <app-layout-comp>
        <div id="UserSettingsView" slot="AppContent" v-bind:class="{'darkMode':themeToDisplay=='dark'}">

          <div class="columns">
            <div class="column">

              <!-- titre de la page ----------------------------------------------->
              <div class="has-text-left appTitle is-hidden-mobile">
                <h3 class=""><font-awesome-icon class="icon" :icon="['fas', 'user-cog']" />{{$t('Réglages')}}</h3>
                <p class="appSubTitle">{{$t('iciVousPouvezModifierVotreCompte')}}</p>
              </div>
            </div>
          </div>


            <user-settings-comp></user-settings-comp>


          <!-- RÉGLAGES ORGANISATION ----------------------------------------------->
          <div class="contOrgSettings" v-if="$auth.hasRole('ROLE_ADMIN')">
            <hr>

            <div class="has-text-left appTitle is-hidden-mobile">
              <h3 class="">
                <font-awesome-icon class="icon" :icon="['fas', 'user-cog']"/>
                {{ $t('RéglagesOrganisation') }}
              </h3>
            </div>

            <!-- Réglage de la devise -->
            <workspace-setting-currency-comp v-if="$auth.hasRole('ROLE_ADMIN')"></workspace-setting-currency-comp>

            <!-- CTA réglage abonnement @todo réactiver pour https://gitlab.com/ousmane1/kronocloud/-/issues/787-->
<!--            <c2a-subscription-settings-comp v-if="$auth.hasRole('ROLE_ADMIN')"></c2a-subscription-settings-comp>-->

            <!-- Suppression du compte -->
            <user-setting-delete-account-comp v-if="$auth.hasRole('ROLE_OWNER')"></user-setting-delete-account-comp>

          </div>

        </div>


    </app-layout-comp>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
    // @ is an alias to /src
    import {mapState} from 'vuex'
    import AppLayoutComp from '@/components/AppLayoutComp.vue'
    import UserSettingsComp from '@/components/UserSettingsComp.vue'
    import VueMetaMixin from "../mixins/VueMetaMixin.js";
    import WorkspaceSettingCurrencyComp from "@/components/WorkspaceSettingCurrencyComp";
    import C2aSubscriptionSettingsComp from "@/components/C2aSubscriptionSettingsComp";
    import UserSettingDeleteAccountComp from "@/components/UserSettingDeleteAccountComp";

    export default {
        name: 'UserSettingsView',
        components: {
          UserSettingDeleteAccountComp,
          C2aSubscriptionSettingsComp,
          WorkspaceSettingCurrencyComp,
            AppLayoutComp,
            UserSettingsComp
        },
        mixins: [VueMetaMixin],

        data:function() {
          return{
            locale : this.$route.params.locale,
            organization:this.$route.params.organization,          }

        },
        computed: {
          // computed props for store :
          ...mapState({
            themeToDisplay: state =>state.app.themeToDisplay
          })
        },
        //==========================================================
        metaInfo(){
            return this.setMeta(this.$t("metaTitleUserSettings"),this.$t("metaDescDefault"))
        },
        //==========================================================
        methods: {

        },
        created: function () {
        },
    }
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
  /*ATTENTION : css non "scoped" s'applique à tout le html*/
  @import "../assets/css/globalVar.scss";
  @import "../assets/css/bulmaCustom.scss";

  /* NOTE : ici on mutualise les styles des blocs de formulaires utilisés dans :
    - UserSettingsComp
    - WorkspaceSettingCurrencyComp
   */

 #UserSettingsView{
   //////////////////////////////////////
   // LIGHT UI ///////////////////////////
   .formSection {
     margin-bottom: 2rem;
     border-radius: 3px;
     border-width: 1px;
     border-color: #ccc;
     border-style: solid;
     background: #f9f9f9;

     .help{

       color: $grey-light;
       font-size: 0.9rem;
       font-style: italic;

       &.is-danger{
         color: $danger
       }
       &.is-warning{
         color: #f8b81f
       }
     }

     .spacer {
       padding: 2rem;
     }
     .contTitle{
       h3{
         //text-align: left;
         color:#666;
         font-size: 1rem;
         font-weight: bold;
         margin-bottom: 1rem ;

         .icon{
           width: 1.4rem;
           color: #ddd;
           margin-right: .3rem;
           vertical-align: bottom;
         }
       }
     }

     .contFoot{

       background: #efefef;
       padding: 0.5rem 2rem;

       @include mobile {
         .control{
           margin-bottom: 0;
         }
       }



       .button{
         padding: 1.2rem 1.5rem;
         .icon {margin-right: 0.5rem; width: 1rem}
         &.is-text{
           text-decoration: none;
           color: #666;
           &:hover{background: none}
         }
       }

     }

     // formulaires
     .control {

       margin: 0 1.5rem 0 0;
       @include mobile {
         margin-bottom: 1rem;
       }

       .label{
         font-size: 0.95rem; color: #444;
         &::first-letter{
           // on force la majuscule sur la 1ère lettre des labels
           text-transform: uppercase;
         }
       }
     }
     //$inputMargin : 0 1rem 0; // la marge des items de formulaire

     .input[type="text"],.input[type="email"],.input[type="password"]{
       background:white;
       padding: 1.5rem 1.5rem !important;
       color: #666;
       //margin: $inputMargin;

       &:focus{
         color: $brandBlue;
         border: solid 1px $brandBlue;
         box-shadow: 0 0 2px $brandBlue;
         transition: box-shadow 400ms;
       }
     }

     select{
       color: #666;
       //margin: $inputMargin;
       //font-size: 18px;
       //padding: 0.3rem 0;
       @include mobile {
         margin-bottom: 1rem;
       }

       option{
         //color: red;
       }


     }
   }
   //////////////////////////////////////
   // DARK UI ///////////////////////////
   &.darkMode {

     $sectionColor: $darkBg4;
     .formSection{
       background: $sectionColor !important;
       border-color: lighten($sectionColor,15%);

       .label{
         color: $darkTxt;
       }
       .help{
         color:#666;
         &.is-danger{color: $danger}
         &.is-warning{color: #f8b81f}
       }
       .contTitle {
         .icon {
           color: lighten($darkFieldBorder,5%);
         }
         h3{
           color: $darkTxt;
         }

       }
     }
     .contFoot{
       background: darken($sectionColor,3%);
     }
     .input{
       //color: $darkTxt !important;
       //background: $darkFieldBg !important;

       //&:focus{
       //  background: gold;
       //}
     }
     //.select select{
     //  color: $darkTxt;
     //  background: $darkFieldBg !important;
     //}
   }
 }

</style>

<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";

    #UserSettingsView {
      .appSubTitle {
        border-bottom: solid 1px #ddd;
        /*background: mintcream;*/
        padding: 0 0 0.4rem;
        margin: 0 0 2rem;

        .icon {
          //color: $brandPrimary;
          //margin-right: 0.8rem;
        }

        h2 {
          /*text-align: left;*/
          font-size: 1.1rem;
          font-weight: bold;
          color: #bbbcba !important;

        }

        .infoLine {
          color: #ccc;
          font-style: italic;
          font-size: 1rem;
        }


      }
      .contOrgSettings{
        margin-top: 4rem;
        hr{
          height: 1px;
          margin-bottom: 3rem;
          background-color: #ddd;
        }
      }



      ////////////////////////////////////////
      //DARK MODE /////////////////////////////
      &.darkMode {
        .appSubTitle {
          border-bottom: solid 1px lighten($darkFieldBorder,10%) !important;
        }
        .contOrgSettings{
          hr{
            background-color: #666;
          }
        }

      }
    }

</style>
